export const questionnaires = {
    'sick-note-work-uni': [
        {
            name: 'primary_reason',
            label: 'What is the primary medical reason/illness for your absence? (e.g., Migraine, Gastroenteritis, Flu symptoms)',
            type: 'text',
            required: true
        },
        {
            name: 'symptomsStartDate',
            label: 'On what date did your symptoms first become severe enough to stop you from working/studying?',
            type: 'date',
            required: true
        },
        {
            name: 'sicknessEndDate',
            label: 'What is the final date you require this sick note to cover? (Note: System caps this at 14 days maximum)',
            type: 'date',
            required: true
        },
        {
            name: 'consultedNHS',
            label: 'Have you already consulted an NHS doctor or 111 about this specific episode?',
            type: 'radio',
            options: ['Yes', 'No'],
            required: true
        },
        {
            name: 'symptomsDescription',
            label: 'Briefly describe how your symptoms prevent you from completing your daily work or university duties:',
            type: 'textarea',
            required: true
        },
    ],
    'academic-exemption': [
        {
            name: 'acute_medical_condition',
            label: 'What is the acute medical condition that impacted your studies?',
            type: 'text',
            required: true
        },
        {
            name: 'assessment_date',
            label: 'What was the exact date of the exam, presentation, or coursework deadline affected?',
            type: 'date',
            required: true
        },
        {
            name: 'module_name',
            label: 'What is the specific name of the university module, course, or assessment?',
            type: 'text',
            required: true
        },
        {
            name: 'impairment_type',
            label: 'Did this condition cause cognitive impairment (e.g., severe lack of concentration, extreme fatigue) or physical impairment (e.g., unable to use a computer, confined to bed)?',
            type: 'radio',
            options: ['Cognitive', 'Physical', 'Both'],
            required: true
        },
        {
            name: 'symptoms_on_day',
            label: 'Provide brief details of your symptoms on the day of the assessment to assist the reviewing doctor:',
            type: 'textarea',
            required: true
        },
    ],
    'carers-leave': [
        {
            name: 'dependentNameAndRelationship',
            label: 'What is the full legal name and relationship to you of the dependent requiring care?',
            type: 'text',
            required: true
        },
        {
            name: 'dependentIllness',
            label: 'What acute illness does the dependent have that requires your full-time presence?',
            type: 'text',
            required: true
        },
        {
            name: 'leaveStartDate',
            label: "What is the start date you are requesting carer's leave for?",
            type: 'date',
            required: true
        },
        {
            name: 'leaveEndDate',
            label: "What is the end date you are requesting carer's leave for?",
            type: 'date',
            required: true
        }
    ],
    'return-to-work': [
        {
            name: 'originalIllness',
            label: 'What was the original illness you were absent for?',
            type: 'text',
            required: true
        },
        {
            name: 'jobTitleAndDuties',
            label: 'What is your current job title and primary daily duties?',
            type: 'text',
            required: true
        },
        { name: 'isSafetyCritical', label: 'Is your role considered safety-critical? (e.g., operating heavy machinery, commercial driving, clinical healthcare, working at heights)', type: 'radio', options: ['Yes', 'No'], required: true },
        { name: 'fitnessConfirmation', label: 'I confirm that my symptoms have completely resolved, I feel 100% fit, and I am under no ongoing medical restrictions that would impair my job safety.', type: 'checkbox', required: true },
    ],
    'default': [
        { name: 'defaultReason', label: 'Please describe the reason for your request.', type: 'textarea', required: true },
    ],
    'admin-travel-exemption': [
        {
            name: 'event_date_start',
            label: 'What is the specific start date of your planned travel, booking, or scheduled event?',
            type: 'date',
            required: true
        },
        {
            name: 'event_date_end',
            label: 'What is the specific end date of your planned travel, booking, or scheduled event?',
            type: 'date',
            required: false // End date might be optional for single-day events
        },
        {
            name: 'medical_condition_allergy',
            label: 'What is the specific medical condition or severe allergy relevant to this request?',
            type: 'text',
            required: true
        },
        {
            name: 'medication_details',
            label: 'If for Travel with Medication/Allergy: List the exact names, dosages, and delivery methods (e.g., EpiPen, liquid insulin) of the medications you must carry through security:',
            type: 'textarea',
        },
        {
            name: 'cancellation_reason',
            label: 'If for Holiday Cancellation: Why does this medical condition make it unsafe or impossible for you to travel?',
            type: 'textarea',
        },
        {
            name: 'jury_duty_reason',
            label: 'If for Jury Duty: Why does your medical condition prevent you from sitting in a courtroom for extended periods?',
            type: 'textarea',
        }
    ],
    'maternity-travel': [
        {
            name: 'pregnancy_type',
            label: 'Is this a singleton (one baby) or multiple (twins/triplets) pregnancy?',
            type: 'radio',
            options: ['Singleton', 'Multiple'],
            required: true
        },
        {
            name: 'edd',
            label: 'What is your current estimated delivery date (EDD)?',
            type: 'date',
            required: true
        },
        {
            name: 'gestational_age_return',
            label: 'What will your exact gestational age (weeks and days) be on your final return travel date? (e.g., 31 weeks + 4 days)',
            type: 'text',
            required: true
        },
        {
            name: 'pregnancy_complications',
            label: 'Have you experienced any of the following during this pregnancy: high blood pressure, gestational diabetes, vaginal bleeding, pre-eclampsia, or a low-lying placenta?',
            type: 'radio',
            options: ['Yes', 'No'],
            required: true
        },
    ],
    'visa-medical': [
        {
            name: 'passportNumber',
            label: 'What is your Passport Number?',
            type: 'text',
            required: true
        },
        {
            name: 'destinationCountry',
            label: "Which country's embassy or consulate are you submitting this medical certificate to?",
            type: 'select',
            options: [
                'Spain', 'China', 'Cayman Islands', 'UAE', 'Saudi Arabia', 'Kuwait', 'Bahrain',
                'St Kitts & Nevis', 'Japan', 'South Africa', 'Italy', 'Barbados', 'Bermuda',
                'Grenada', 'Maldives', 'Qatar', 'Thailand', 'Vietnam', 'Taiwan', 'Indonesia',
                'South Korea', 'Malaysia', 'Philippines', 'Singapore', 'Brunei', 'Cambodia',
                'Laos', 'Myanmar', 'Timor-Leste', 'Other'
            ],
            required: true
        },
        {
            name: 'medicalHistoryCheck',
            label: 'Do you have any history of, or active treatment for, the following: Pulmonary Tuberculosis, severe substance or alcohol dependency, or an active psychosis requiring psychiatric hospital admission?',
            type: 'radio',
            options: ['Yes', 'No'],
            required: true
        },
        // Note: The file upload slots are handled by the Account component's logic based on service requirements.
        // The dynamic logic for Singapore/Indonesia will need to be implemented in the Questionnaire/Account component.
        {
            name: 'hivTestResult',
            label: 'HIV Blood Test Result (Required for Singapore/Indonesia)',
            type: 'file',
        },
        {
            name: 'chestXrayReport',
            label: 'Chest X-Ray Radiology Report (Required for Singapore/Indonesia)',
            type: 'file',
        }
    ],
    'clinical-recovery': [
        {
            name: 'diagnosis_date',
            label: 'On what date were you originally diagnosed with this infection or condition?',
            type: 'date',
            required: true
        },
        {
            name: 'treatment_prescribed',
            label: 'What treatment or course of medication (e.g., Amoxicillin, Aciclovir) were you prescribed?',
            type: 'text',
            required: true
        },
        {
            name: 'active_symptoms',
            label: 'Are you currently experiencing a fever, open or weeping skin blisters, a productive cough, or any active pain?',
            type: 'radio',
            options: ['Yes', 'No'],
            required: true
        },
        {
            name: 'recovery_confirmation',
            label: 'I confirm that I have completed my treatment course, I have been entirely symptom-free for at least 48 hours, and I feel fully physically recovered.',
            type: 'checkbox',
            required: true
        }
    ],
};